<script lang="ts" setup>
const items = [
  'multibilet.individualPath.item1',
  'multibilet.individualPath.item2',
  'multibilet.individualPath.item3',
  'multibilet.individualPath.item4',
]
</script>

<template>
  <section class="individual-path">
    <div class="individual-path__wrapper">
      <h3 class="individual-path__title">
        {{ $t('multibilet.individualPath.title') }}
      </h3>

      <p
        class="individual-path__terms"
        v-html="$t('multibilet.individualPath.terms')">
      </p>

      <ul class="individual-path__list">
        <li
          v-for="(item, index) in items"
          :key="`${item}-${index}`"
          class="individual-path__item"
        >
          <span class="individual-path__number">0{{ index + 1 }}</span>
          <p>{{ $t(item) }}</p>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.individual-path {
  padding: 4rem 1.6rem 2.4rem;

  &__wrapper {
    max-width: 120rem;
    margin: 0 auto;
    padding: 3.2rem 1.6rem;
    background: linear-gradient(180deg, #f3f5f7 0%, #ffffff 100%);
    border-radius: 2.4rem;
  }

  &__title {
    @include h8;
    margin-bottom: 1.6rem;
    color: $text-400;
    text-align: center;
  }

  &__terms {
    @include body-2-medium;
    margin: 0 0 2.4rem;
    color: $text-400;
    text-align: center;
  }

  &__list {
    display: grid;
    gap: 1.6rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__item {
    display: grid;
    align-items: start;
    grid-template-columns: auto 1fr;
    gap: 1.2rem;
    padding: 1.6rem 1.2rem;
    color: $text-400;
    background: $white;
    border-radius: 1.6rem;
    box-shadow: 0 0 0 1px rgba(24, 39, 55, 0.08);
    @include body-1-medium;
  }

  &__number {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 4rem;
    height: 4rem;
    color: $white;
    font-weight: 700;
    background: $text-400;
    border-radius: 50%;
  }
}

@include atM {
  .individual-path {
    padding: 6rem 3.2rem 2.8rem;

    &__title {
      @include h5;
    }

    &__list {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 2.4rem;
    }

    &__item {
      padding: 2.4rem 1.6rem;
    }
  }
}
</style>
